// extracted by mini-css-extract-plugin
export default {"uploadContainer":"input_uploadContainer__dbl-2","uploadArea":"input_uploadArea__NPKSS","coverContainer":"input_coverContainer__6CFD0"};